const reservation_model = {
    agency_name: '',
    channel: '',
    check_in: '',
    check_out: '',
    commissioning_details: {
        agency:{
            commission_percentage: '',
            commission_value: '',
            commissionable_value: '',
            currency: '',
            should_commission: false
        },
        hotel: {
            commission_percentage: '',
            commission_value: '',
            commissionable_value: '',
            currency: '',
            should_commission: false
        },
        created_at: ''
    },
    customer: {
        contact: {
            address: {
                building: '',
                city: '',
                country: '',
                number: '',
                state: '',
                street: ''
            },
            email: '',
            phone: ''
        },
        id: null,
        context: 'imemento',
        first_name: '',
        title: '',
        last_name: '',
        observations: '',
    },
    deleted_at: '',
    external_id: '',
    hotel_id: '',
    invoicing_details: {
        booking_value: '',
        commission_percentage: '',
        commission_value: '',
        currency: '',
        customer: {
            name: '',
            fiscal_code: '',
            id: '',
            point_of_business: '',
            registry_number: '',
            type: '',
            address: {
                building: '',
                city: '',
                country: '',
                number: '',
                state: '',
                street: ''
            },
            contact:  {
                name: '',
                email: '',
                phone: '',
                position: ''
            },
            banks: []
        },
        invoice_value: ''
    },
    pax: {
        adults: null,
        infants: null,
        half_seats: null,
        full_seats: null
    },
    pricing: {
        total: 0,
        currency: null,
        after_tax: null,
        before_tax: null,
        paid_amount: null,
        payable_amount: null,
        booking_currency: null,
        booking_total: null,
        booking_exchange_rate: null
    },
    is_agency: false,
    nights: '',
    observations: {
        client: '',
        platform: ''
    },
    payment: {
        data: {},
        type: null,
        viewed: null,
    },
    rooms: [{
        cancellation_policy: {
            description: '',
            rules: ''
        },
        check_in: null,
        check_out: null,
        meal_type: '',
        pax: {
            adults: null,
            infants: null,
            half_seats: null,
            full_seats: null
        },
        price: [{
            amount: 0,
            currency: null,
            date: null,
        }],
        rate_plan: {
            id: null,
            meal_type: '',
            name: ''
        },
        room_type: {
            id: null,
            name: '',
            type: ''
        },
        services: [],
        status: '',
        total_price: {
            amount: 0,
            currency: null
        }
        
    }],
    source: '',
    status: '',
    updated_at: ''
};

const hotel_model = {
    address: {
        building: '',
        city: '',
        country: '',
        number: '',
        state: '',
        postal_code: '',
        street: ''
    },
    billing: {
        vouchers_accepted: null,
    },
    context: 'imemento',
    gross_commission: '12.00',
    net_commission: '25.00',
    country_code: "RO",
    created_at: null,
    deleted_at: null,
    description: {
        en: null,
        ro: null
    },
    email: null,
    email_orig: null,
    financial: {
        banks: []
    },
    index: null,
    language: 'ro',
    name: "",
    org_id: null,
    static: {
        activities: [],
        contact: {
            email: null,
            person: null,
            phone: null,
            position: null
        },
        defaults: {
            capacity: null,
            certificate: null,
            certificate_status: null,
            chain: null,
            currency: 'RON',
            fax: null,
            phone: null,
            stars: 3,
            timezone: 'Europe/Bucharest',
            website: null,
            weekend: ["6", "0"]
        },
        facilities: {},
        financial: {
            accepted_cards: [],
            address: null,
            bank_currency: null,
            bank_iban: null,
            bank_name: null,
            city: null,
            company: null,
            country: null,
            cui: null,
            currencies: ["RON"],
            nr_reg_com: null,
            pre_authorization: null
        },
        for_testing: 0,
        geo: {
            address: null,
            city: null,
            lat: 44.439663,
            lon: 26.096306,
            postcode: null,
            region: null
        },
        policy: {
            checkin: {
                from: '13:00',
                to: '24:00'
            },
            checkout: {
                from: '09:00',
                to: '12:00'
            },
            extra_beds: {
                type: null,
                value: null
            },
            single_stay: {
                type: null,
                value: null
            },
            children: {
                allowed: true,
                infants: {
                    allowed: true,
                    age: {
                        from: 0,
                        to: 2
                    },
                    price: {
                        type: "percent",
                        value: "25"
                    }
                },
                small_children: {
                    allowed: true,
                    age: {
                        from: 2,
                        to: 6
                    },
                    price: {
                        type: "percent",
                        value: "50"
                    }
                },
                big_children: {
                    allowed: true,
                    age: {
                        from: 6,
                        to: 17
                    },
                    price: {
                        type: "percent",
                        value: "100"
                    }
                }
            },
            spoken_languages: ["ro","en"]
        },
        images: [],
        video: null
    },
    slug: null,
    status: 'registered',
    terms: {
        en: null,
        ro: null
    },
    unit_type: 'hotel',
    updated_at: null
};

let room_type_model = {
    close_out: false,
    config: {
        area: null,
        extra_beds: 0,
        facilities: {},
        occupancy: '',
        single_stay: 0,
        small_child_in_bed: 0
    },
    count: null,
    description: null,
    images: [],
    name: null,
    price: null,
    standard: null,
    slug: null,
    rate_plans: []
};

const cancellation_policy_model = {
    name: "",
    refundable: false,
    hotel_id: null,
    rules: [],
    text: {
        ro: "",
        en: ""
    }
};

const rate_plan_model = {
    cancellation_policy_id: "",
    component_based: false,
    config: {
        book_before: "",
        cancellation_allowed: false,
        date: {
            start: "",
            stop: ""
        },
        formula:{
            operation: "add",
            type: "percent",
            value: 0
        },
        rule: {
            operation: 0,
            value: "",
            type: 0
        },
        min_stay: "",
        max_stay: "",
        weekdays: []
    },
    description: null,
    hotel_id: null,
    net_prices: false,
    meal_type: 'room-only',
    name: null,
    pos: ["mementobookings", "christiantour", "helloromania"],
    room_types: [],
    stop_sell: true,
};

const user_model = {
    about: null,
    address: {
        country: null,
        street: null,
        city: null,
        region: null,
        number: null,
        building: null,
        postal_code: null,
    },
    avatar: null,
    birthdate: {
        day: null,
        month: null,
        year: null
    },
    email: '',
    password: '',
    password_confirmation: '',
    first_name: '',
    full_name: null,
    gender: null,
    last_name: null,
    logged_at: null,
    nickname: null,
    organization: {
        id: null,
        name: null,
        type: null
    },
    organization_id: '',
    phone: null,
    timezone: null,
    title: null,
    website: null,
    social: {
        facebook: null,
        google_plus: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        instagram: null,
        pinterest: null,
        tumblr: null
    }
};
const organization_model = {
    about: '',
    address: {
        country: '',
        street: '',
        city: '',
        region: '',
        number: '',
        building: '',
        postal_code: '',
    },
    contact: {
        name: '',
        email: '',
        phone: '',
        position: ''
    },
    avatar: '',
    created_at: '',
    email: '',
    name: '',
    logged_at: '',
    parent_id: '',
    phone: '',
    timezone: '',
    website: '',
    social: {
        facebook: '',
        google_plus: '',
        twitter: '',
        linkedin: '',
        youtube: '',
        instagram: '',
        pinterest: '',
        tumblr: ''
    }
};
const billing_model = {
    name: null,
    type: null,
    fiscal_code: null,
    registry_number: null,
    email: null,
    point_of_business: null,
    banks: [{
        name: null,
        account: null,
        currency: null,
    }],
    contact: {
        name: null,
        email: null,
        phone: null,
        position: null,
    },
    address: {
        country: null,
        state: null,
        city: null,
        street: null,
        number: null,
        building: null,
        postal_code: null,
    }
};

let sheet = {};

let rate_plan_name = "";
let room_type_name = "";
let policy_name = "";

export default {
    'reservation_item': reservation_model,
    'hotel_item': hotel_model,
    'room_type_item': room_type_model,
    'cancellation_policy_item': cancellation_policy_model,
    'rate_plan_item': rate_plan_model,
    'user_item': user_model,
    'organization_item': organization_model,
    'billing_item': billing_model,
    'sheet_model': sheet,
    'rate_plan_name': rate_plan_name,
    'room_type_name': room_type_name,
    'policy_name': policy_name,
};
